import React, { Component } from 'react';
import '../../css/admin/ComponenteSpinner.css';
import { memo } from 'react';
/*import MaterialTable, { MaterialTableProps } from 'material-table';*/
import MaterialTable, { Column } from "@material-table/core";

export class MaterialTableAdmin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            inicioSesion: "",
        }

    }

    render() {
        return (
            <MaterialTable
                title=""
                columns={this.props.columns}
                data={this.props.data}
                actions={this.props.actions}
                options={{
                    actionsColumnIndex: -1,
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 40, 60],
                    headerStyle: { backgroundColor: '#767E9F', color: 'white', fontWeight: 'bold', zIndex: 0, paddingRight: '50px' }
                }}
                localization={{
                    header: { actions: "Acciones" },
                    toolbar: { searchPlaceholder: 'Filtrar' },
                    pagination: { labelRowsSelect: "Filas" },
                }}
                isLoading={this.props.isLoading}
            ></MaterialTable>
        );
    }
}

export default memo(MaterialTableAdmin);
